module.exports = __webpack_public_path__ + "static/media/mortar-pestle.ea514d15.svg";